import React from 'react';
import { Link } from 'react-router-dom';
import { getDatabase, get, ref, child } from "firebase/database";
import * as lang from '../../lang';

var loadingTimer;

export default class InventoryPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            etherians: {},
            loading: true,
            accountPower: 0,
            selected: null,
            backgroundType: "sun"
        }
    }

    async getData() {
        if (window) {
            if (window.web3) {
                if (window.ethereum) {
                    if (this.props.drizzleState) {
                        try {
                            let accountPower = await this.props.drizzle.contracts.Woe.methods.power(this.props.drizzleState.accounts[0]).call();
                            let sunTokens = await this.props.drizzle.contracts.Crystals.methods._balanceOf(this.props.drizzleState.accounts[0], 1).call();
                            let oceanTokens = await this.props.drizzle.contracts.Crystals.methods._balanceOf(this.props.drizzleState.accounts[0], 2).call();
                            let lifeTokens = await this.props.drizzle.contracts.Crystals.methods._balanceOf(this.props.drizzleState.accounts[0], 3).call();
                            let deathTokens = await this.props.drizzle.contracts.Crystals.methods._balanceOf(this.props.drizzleState.accounts[0], 4).call();
                            let astralTokens = await this.props.drizzle.contracts.Crystals.methods._balanceOf(this.props.drizzleState.accounts[0], 5).call();
                            this.setState({
                                sunTokens: sunTokens,
                                oceanTokens: oceanTokens,
                                lifeTokens: lifeTokens,
                                deathTokens: deathTokens,
                                astralTokens: astralTokens,
                                accountPower: accountPower
                            })

                            let tarLoc = this.props.dataLocale.toLowerCase() + "accounts/" + this.props.drizzleState.accounts[0].toLowerCase() + "/etherians";
                            const dbRef = ref(getDatabase());
                            get(child(dbRef, tarLoc)).then((snapshot) => {
                                if (snapshot.exists()) {
                                    this.setState({
                                        etherians: snapshot.val(),
                                        loading: false,
                                    })
                                    console.log('here 1111')
                                } else {
                                    console.log('here 2222')
                                    this.setState({
                                        loading: false
                                    })
                                }
                            }).catch((error) => {
                                console.error(error);
                            });
                            clearInterval(loadingTimer);
                        } catch (error) {
                            this.setState({
                                loading: false
                            })
                            clearInterval(loadingTimer);
                        }
                    }
                }
            }
        }
    }

    async componentDidMount() {
        loadingTimer = setInterval(async () => {
            this.getData();
        }, 100);
    }

    componentWillUnmount() {
        clearInterval(loadingTimer);
    }

    renderPlayerData() {
        return (
            <>
                <h2>Token Balance</h2>
                <br />
                <h2>
                    <span role="img" aria-label="Sun">☀️</span>
                    {this.state.sunTokens} &nbsp;

                    <span role="img" aria-label="Tide">🌊</span>
                    {this.state.oceanTokens} &nbsp;

                    <span role="img" aria-label="Broccoli">🥦</span>
                    {this.state.lifeTokens} &nbsp;

                    <span role="img" aria-label="Skull">💀</span>
                    {this.state.deathTokens} &nbsp;

                    <span role="img" aria-label="Crystal Ball">🔮</span>
                    {this.state.astralTokens}</h2> &nbsp;

                <br />
                <h2>Attack Power: {this.state.accountPower}</h2>
                <br />
            </>
        )
    }

    changeSelected(cng, eType) {
        this.setState({
            selected: cng,
            backgroundType: eType
        })
    }

    convertBaseToSpecies(type, species) {
        if (type === 5 && species == 0) {
            type = "astral";
        } else if (type === 1) {
            type = "sun"
        } else if (type === 2) {
            species = species + 40;
            type = "ocean"
        } else if (type === 3) {
            species = species + 80;
            type = "life"
        } else if (type === 4) {
            species = species + 120;
            type = "death"
        } else if (type === 5) {
            species = species + 160;
            type = "astral";
        }
        let name = this.props._globals.getName(species);
        return [type, species, name]
    }

    renderEtherians() {
        return Object.keys(this.state.etherians).map(y => {
            let f = this.state.etherians[y];
            let isactive = ""
            let name;
            let species;
            let type;
            let cap = this.convertBaseToSpecies(f.eType, f.species);

            type = cap[0];
            species = cap[1];
            name = cap[2];

            if (this.state.selected === y) {
                isactive = `active-${type}`;
            }

            return <div className={`inv-cell ${isactive}`} key={f.id} onClick={() => this.changeSelected(y, type)}>
                <img src={`https://woe2.s3.amazonaws.com/newmonsters/${species.toString().padStart(3, '0')}${f.isGold ? "g" : ""}.png`} className={`adj-${species}`} alt="avatar" />
            </div>
        })
    }

    render() {
        let death = <div className="restrain" ><div className="image--light deaths"> <div> <div className="death"></div> <div className="falling-skulls"> <div className="skull x1" ></div> <div className="skull x2" ></div> <div className="skull x3" ></div> <div className="skull x5" ></div> <div className="skull x8" ></div> <div className="skull x9" ></div> <div className="skull x11" ></div> <div className="skull x29" ></div> <div className="light-skull"> <div className="bigskull x4" ></div> </div> </div> <div className="left-skulls"> <div className="skull-cont0"> <div className="skull" ></div> </div> <div className="skull-cont1"> <div className="skull" ></div> </div> <div className="skull-cont2"> <div className="skull" ></div> </div> <div className="skull-cont3"> <div className="skull" ></div> </div> <div className="skull-cont4"> <div className="skull" ></div> </div> <div className="skull-cont5"> <div className="skull" ></div> </div> <div className="skull-cont6"> <div className="skull" ></div> </div> <div className="skull-cont7"> <div className="skull" ></div> </div> <div className="skull-cont8"> <div className="skull" ></div> </div> <div className="skull-cont9"> <div className="skull" ></div> </div> <div className="skull-cont10"> <div className="skull" ></div> </div> <div className="skull-cont11"> <div className="skull" ></div> </div> <div className="skull-cont12"> <div className="skull" ></div> </div> <div className="skull-cont13"> <div className="skull" ></div> </div> <div className="skull-cont14"> <div className="skull" ></div> </div> <div className="skull-cont15"> <div className="skull" ></div> </div> <div className="skull-cont16"> <div className="skull" ></div> </div> <div className="skull-cont17"> <div className="skull" ></div> </div> <div className="skull-cont18"> <div className="skull" ></div> </div> </div> <div className="right-skulls"> <div className="skull-cont19"> <div className="skull" ></div> </div> <div className="skull-cont20"> <div className="skull" ></div> </div> <div className="skull-cont21"> <div className="skull" ></div> </div> <div className="skull-cont22"> <div className="skull" ></div> </div> <div className="skull-cont23"> <div className="skull" ></div> </div> <div className="skull-cont24"> <div className="skull" ></div> </div> <div className="skull-cont25"> <div className="skull" ></div> </div> <div className="skull-cont26"> <div className="skull" ></div> </div> <div className="skull-cont27"> <div className="skull" ></div> </div> <div className="skull-cont28"> <div className="skull" ></div> </div> <div className="skull-cont29"> <div className="skull" ></div> </div> <div className="skull-cont30"> <div className="skull" ></div> </div> <div className="skull-cont31"> <div className="skull" ></div> </div> <div className="skull-cont32"> <div className="skull" ></div> </div> <div className="skull-cont33"> <div className="skull" ></div> </div> <div className="skull-cont34"> <div className="skull" ></div> </div> <div className="skull-cont35"> <div className="skull" ></div> </div> <div className="skull-cont36"> <div className="skull" ></div> </div> <div className="skull-cont37"> <div className="skull" ></div> </div> </div> </div> </div></div>
        let ocean = <div className="restrain" ><div className="image--light waters"> <div> <div className="sun-holder"> <div className="water-sun"> <div className="water-glow-1"></div> <div className="water-glow-2"></div> <div className="water-glow-3"></div> </div> </div> <div className="bubble x1"></div> <div className="bubble x2"></div> <div className="bubble x3"></div> <div className="bubble x4"></div> <div className="bubble x5"></div> <div className="bubble x6"></div> <div className="bubble x7"></div> <div className="bubble x8"></div> <div className="bubble x9"></div> <div className="bubble x10"></div> <div className="bubble x11"></div> <div className="bubble x12"></div> <div className="bubble x13"></div> <div className="bubble x14"></div> <div className="bubble x15"></div> <div className="bubble x16"></div> <div className="bubble x17"></div> <div className="bubble x18"></div> <div className="bubble x19"></div> <div className="bubble x20"></div> <div className="bubble x21"></div> <div className="bubble x22"></div> <div className="bubble x23"></div> <div className="bubble x24"></div> <div className="bubble x25"></div> <div className="bubble x26"></div> <div className="bubble x27"></div> <div className="bubble x28"></div> <div className="bubble x29"></div> <div className="bubble x30"></div> <div className="bubble x31"></div> <div className="hill-bg-1"></div> <div className="hill-bg-2"></div> <div className="hill-fg-2"></div> <div className="hill-fg-3"></div> </div> </div></div>
        let life = <div className="restrain" ><div className="bigLeafWrap"> <div className="scene"> <div className="foreground"> <div className="leaf x1"></div> <div className="leaf2 x2"></div> <div className="leaf x3"></div> <div className="leaf2 x4"></div> <div className="leaf x5"> </div> <div className="leaf x8"></div> <div className="leaf x9"></div> <div className="leaf2 x10"></div> <div className="leaf x11"></div> <ul className="trees3"> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> </ul> <ul className="trees2"> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> </ul> <ul className="trees1"> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> <li></li> </ul> </div> </div> </div></div>
        let sun = <div className="restrain" ><div className="image--light suns"> <div className="sun-holder"> <div className="top"> <div className="stars"> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> <div className="star"></div> </div> <div className="shooting-star"></div> <div className="shooting-star2"></div> <div className="shooting-star3"></div> <div className="sun"> <div className="sun-glow-1"></div> <div className="sun-glow-2"></div> <div className="sun-glow-3"></div> </div> <div className="pyramids"> <div className="pyramid hidden-xs hidden-sm"></div> <div className="pyramid hidden-xs hidden-sm"></div> <div className="pyramid hidden-xs hidden-sm"></div> <div className="pyramid hidden-xs hidden-sm"></div> </div> </div> </div> </div></div>
        let astral = <div className="restrain astralbodyh" ><div class="start"><div id="normalstar"></div><div id="star"></div></div></div>
        let backType;
        if (this.state.backgroundType === "sun") {
            backType = sun;
        }
        if (this.state.backgroundType === "ocean") {
            backType = ocean;
        }
        if (this.state.backgroundType === "life") {
            backType = life;
        }
        if (this.state.backgroundType === "death") {
            backType = death;
        }
        if (this.state.backgroundType === "astral") {
            backType = astral;
        }

        let type;
        let name;
        let species;

        if (this.state.selected) {
            let a = this.state.etherians[this.state.selected];
            let cap = this.convertBaseToSpecies(a.eType, a.species);
            type = cap[0];
            species = cap[1];
            name = cap[2];
        }

        let sun_tokens = "000";
        let ocean_tokens = "000";
        let life_tokens = "000";
        let death_tokens = "000";
        let astral_tokens = "000";

        if (this.state.sunTokens) {
            if (this.state.sunTokens > 9999) {
                sun_tokens = ">9999";
            } else {
                sun_tokens = this.state.sunTokens.toString().padStart(3, '0')
            }
        }
        if (this.state.oceanTokens) {
            if (this.state.oceanTokens > 9999) {
                ocean_tokens = ">9999";
            } else {
                ocean_tokens = this.state.oceanTokens.toString().padStart(3, '0')
            }
        }
        if (this.state.lifeTokens) {
            if (this.state.lifeTokens > 9999) {
                life_tokens = ">9999";
            } else {
                life_tokens = this.state.lifeTokens.toString().padStart(3, '0')
            }
        }
        if (this.state.deathTokens) {
            if (this.state.deathTokens > 9999) {
                death_tokens = ">9999";
            } else {
                death_tokens = this.state.deathTokens.toString().padStart(3, '0')
            }
        }
        if (this.state.astralTokens) {
            if (this.state.astralTokens > 9999) {
                astral_tokens = ">9999";
            } else {
                astral_tokens = this.state.astralTokens.toString().padStart(3, '0')
            }
        }
        return (
            <>
                {backType}
                <div style={{ height: "100vh", width: "100vw", position: "fixed" }}>
                    <div className="wrap">
                        <div id="navigation">
                            <div id="logo">
                                <Link to="/">
                                    <img src="https://woe2.s3.amazonaws.com/logo.png" alt="logo" />
                                </Link>
                            </div>
                            <div id="menu-right" >
                                <Link to="/roadmap">
                                    <div className={`mask ${this.props.lang} dark-menu-${this.state.backgroundType}`}>
                                        <div className="mask-inner">
                                            {lang.roadmap[this.props.lang]}
                                        </div>
                                    </div>
                                </Link>
                                <Link to="/woedex">
                                    <div className={`mask2 ${this.props.lang} dark-menu-${this.state.backgroundType}`}>
                                        <div className="mask-inner">
                                            {lang.collection[this.props.lang]}
                                        </div>
                                    </div>
                                </Link>

                                <Link to="/buy">
                                    <div className={`rmmobile  mask2 ${this.props.lang}`} style={{ width: 117 }}>
                                        <div className="mask-inner">
                                            PURCHASE
                                            {/* {lang.collection[this.props.lang]} */}
                                        </div>
                                        {/* <img src="https://woe2.s3.amazonaws.com/metamask.png" alt="metamask icon" /> */}
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div id="inventory">
                        <div id="inv-wrap">
                            <div className="inv-left">
                                <div className="inv-dropdowns">
                                    {/* <div className="inv-drop-1"> */}
                                    {/* <div className="inv-drop-title">
                                            TYPE
                                        </div>
                                        <select name="cars" id="select-drop3" value={this.state.faction} onChange={(e) => this.changeFacEgg(e, "faction")}>
                                            <option value="sun">Sun</option>
                                            <option value="ocean">Ocean</option>
                                            <option value="life">Life</option>
                                            <option value="death">Death</option>
                                            <option value="astral">Astral</option>
                                        </select> */}
                                    {/* </div> */}
                                    {/* <div className="inv-drop-2"> */}
                                    {/* <div className="inv-drop-title">
                                            RARITY
                                        </div>
                                        <select name="cars" id="select-drop3" value={this.state.faction} onChange={(e) => this.changeFacEgg(e, "faction")}>
                                            <option value="sun">Sun</option>
                                            <option value="ocean">Ocean</option>
                                            <option value="life">Life</option>
                                            <option value="death">Death</option>
                                            <option value="astral">Astral</option>
                                        </select> */}
                                    {/* </div> */}
                                </div>
                                <div className="inv-grid-contain">
                                    {this.renderEtherians()}
                                </div>
                            </div>
                            <div className="inv-mid">
                                <div className="token-bal">
                                    <img src="https://woe2.s3.amazonaws.com/suntok.png" alt="token" />
                                    {sun_tokens}
                                    <img src="https://woe2.s3.amazonaws.com/oceantok.png" alt="token" />
                                    {ocean_tokens}
                                    <img src="https://woe2.s3.amazonaws.com/lifetok.png" alt="token here" />
                                    {life_tokens}
                                    <img src="https://woe2.s3.amazonaws.com/deathtok.png" alt="token here" />
                                    {death_tokens}
                                    <img src="https://woe2.s3.amazonaws.com/astraltok.png" alt="token here" />
                                    {astral_tokens}
                                </div>
                                <div className={`eoval-border --${this.state.backgroundType}`}>
                                    <div className="eoval">
                                        {this.state.selected ?
                                            <img src={`https://woe2.s3.amazonaws.com/newmonsters/${String(species).padStart(3, '0')}${this.state.etherians[this.state.selected].isGold ? "g" : ""}.png`} alt="avatar" />
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                                <div className={`etherian-text-desc -desc-${this.state.backgroundType}`}>
                                    {this.state.selected ?
                                        <>
                                            <div className="etd-line-1">
                                                #{this.state.etherians[this.state.selected].id} | {name}
                                            </div>
                                            <div className="etd-line-2">
                                                {this.state.etherians[this.state.selected].rarity} {this.state.etherians[this.state.selected].isGold ? " Golden " : ""}{type.charAt(0).toUpperCase() + type.substring(1)} Etherian <img src={this.state.backgroundType == "life" ? "https://woe2.s3.amazonaws.com/shieldgreen.png" : "https://woe2.s3.amazonaws.com/shield.png"} alt="shield" /> {this.state.etherians[this.state.selected].power}
                                            </div>
                                        </>
                                        :
                                        null
                                    }
                                </div>
                                <div className="craft-button-oval">
                                    {this.state.selected ?

                                        // <Link to={`/etherian/${this.state.etherians[this.state.selected].id}`}>
                                        <div className="craft-button">
                                            MANAGE ETHERIAN
                                        </div>
                                        // </Link>

                                        :

                                        null}

                                </div>
                            </div>
                            <div className="inv-right">
                                <div className="right-info-box">
                                    <div className="rib-line-1">
                                        Stake Etherian
                                    </div>
                                    <div className="rib-line-2">
                                        Make crystals by staking but be careful you are vulnerable on withdrawl.
                                    </div>
                                    <div className="stake-button-oval">
                                        <div className="stake-button">
                                            STAKE wallet
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}